<template>
    <div class="modal fade" id="registarPasswordModal" tabindex="-1" role="dialog"
         aria-labelledby="registarPasswordModalLabel">
        <div class="modal-dialog modal-sm" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="row">
                        <input class="modal-input" type="password" placeholder="PASSWORD" v-model="password"/>
                        <hr>
                        <input class="modal-input" type="password" placeholder="CONFIRM PASSWORD"
                               v-model="confirmPassword"/>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="modal-footer-container">
                        <button class="modal-button modal-red-button" @click="clearAndHideModal" :disabled="isButtonsDisabled">CANCEL</button>
                        <button class="modal-button modal-green-button" @click="signUpClicked" :disabled="isButtonsDisabled">ACTIVATE</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "register-password-modal",
        data() {
            return {
                password: null,
                confirmPassword: null,
                isButtonsDisabled: false
            }
        },
        methods: {
            showModal() {
                $('#registarPasswordModal').modal('show');
            },
            hideModal() {
                $('#registarPasswordModal').modal('hide');
            },
            signUpClicked() {
                this.isConfirmButtonDisabled = true;
                this.$emit("signUpClicked", {
                    password: this.password,
                    confirmPassword: this.confirmPassword
                })
            },
            clearAndHideModal() {
                this.password = null;
                this.confirmPassword = null;
                $('#registarPasswordModal').modal('hide');
            }
        },
        mounted() {
            $('#registarPasswordModal').modal({show: false});
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modals/RegisterPasswordModal.vue